import React, { useCallback, useState } from 'react';
import { Form } from 'react-final-form';
import { useSearch } from 'Shared/actions/search';
import cn from 'classnames';
import { isEmptyString } from 'Shared/helpers';

import SearchInput from './SearchInput';
import SearchResults from './SearchResults';
import SearchSideBar from './SearchSideBar';
import SearchSpinner from './SearchSpinner';
import AutoSaveOnBlur from './AutoSave';
import ImagePlaceholder from './ImagePlaceholder';
import SupportArticles from './SupportArticles/SupportArticles';
import Controls from './Controls';
import { decorator } from './utils';

import './index.scss';

type Props = {
  onOpenToggle?: Function;
};

function SearchModule({ onOpenToggle }: Props) {
  const [page, setPage] = useState(1);
  const [search] = useSearch();

  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const handleSave = useCallback(values => search(values).then(() => setPage(1)), [search]);

  const handlePageChange = useCallback(values => search(values), [search]);

  const filtersOpenToggle = useCallback(() => setIsFiltersOpen(!isFiltersOpen), [isFiltersOpen]);

  const initialValues = {
    searchStr: '',
    completed: 'all',
  };

  return (
    <Form initialValues={initialValues} decorators={[decorator]} onSubmit={handleSave}>
      {({ handleSubmit, pristine, values, submitSucceeded }) => (
        <form className="w-100 d-flex flex-column search-module" onSubmit={handleSubmit}>
          <AutoSaveOnBlur save={handleSubmit} />
          <SearchInput name="searchStr" onSubmit={handleSubmit} />
          <div className="d-flex w-100 h-100 flex-column flex-sm-row">
            <div
              className={cn('position-relative w-100 h-100 search-module-container d-flex flex-column', {
                'search-module-container--show-filters': isFiltersOpen,
              })}
            >
              <SearchSpinner />
              <ImagePlaceholder hide={!isEmptyString(values.searchStr)} />
              <div
                className={cn('w-100 bg-white d-flex position-relative rounded search-module-content', {
                  'search-module-content--show': !pristine && submitSucceeded && !isEmptyString(values.searchStr),
                })}
                style={{ maxHeight: '80%' }}
              >
                <div className="d-flex flex-column w-100" style={{ maxHeight: '100%' }}>
                  <Controls isOpen={isFiltersOpen} onOpen={filtersOpenToggle} />
                  <SearchResults
                    onOpenToggle={onOpenToggle}
                    onPageChange={handlePageChange}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              </div>
              <SupportArticles />
            </div>
            <SearchSideBar isOpen={isFiltersOpen} onFilterOpenToggle={filtersOpenToggle} />
          </div>
        </form>
      )}
    </Form>
  );
}

export default SearchModule;
